import { Disposable, Injectable, InjectableConstructor, INJECTION_TOKEN } from './Injectable';
import { type SystemConstructor, SYSTEMS_TOKEN } from './System';

import type { UnionToIntersection } from 'type-fest';

export const MODULES_TOKEN = Symbol.for('BaseModule');

/**
 * A base module that defines a `build` method which returns an optional public api.
 */
export interface BaseModule<Api extends Record<string, any> = {}> extends Injectable {
  /**
   * A method that returns an optional public api.
   *
   * @remarks
   *
   * Must not be `any` and add `readonly` keyword on implementation
   */
  readonly api: Api;
}

export type ModuleApi<Module extends BaseModule> = Module extends BaseModule<infer Api> ? Api : never;

export type ModuleConstructor<Module extends BaseModule = BaseModule> = InjectableConstructor<Module> & {
  [INJECTION_TOKEN]?: InjectableConstructor[];
  [SYSTEMS_TOKEN]?: SystemConstructor[];
};

export type ModulesApi<Modules extends BaseModule[]> = UnionToIntersection<Modules[number]['api']>;
